import { A4uCoverImage as IconComponent } from '@adobe/react-spectrum-workflow/dist/CoverImage.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function CoverImage(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}